export const ROUTES = {
  HOME: '/',
  SETTINGS: '/settings',
  LOGIN: '/login',
  STATS: '/stats',
  PRODUCTS: '/products',
  PRICES: '/prices',
} as const;

export const INDICATOR_POLLING_INTERVAL = 2000;
